import { useFetchMobilePlanPickers } from '~/scopes/product-core/composables/useFetch/useFetchMobilePlanPickers/useFetchMobilePlanPickers'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/composables/useProductPrice/useProductPrice'
import { useFetchServicePickers } from '~/scopes/product-core/composables/useFetch/useFetchServicePickers/useFetchServicePickers'

export function useFetchProductPrice() {
  const { selectedOffer } = useFetchPickers()
  // Merged mobile-plan (server) + Trade-In (client) pickers — drives the UI price. Populated
  // from first render with at least the mobile-plan groups (server-side, resolved during SSR),
  // with Trade-In appended once the client-only fetch lands — no flash of the wrong price.
  const { data: servicesPickersResponse } = useFetchServicePickers()
  // Mobile-plan pickers only (server-side, no Trade-In) — drives the JSON-LD price. Dedupes
  // against the call already made inside `useFetchServicePickers` (same cache key).
  const { data: mobilePlanPickersResponse } = useFetchMobilePlanPickers()

  const uiPrice = useProductPrice({
    pickers: servicesPickersResponse,
    selectedOffer,
  })

  /**
   * Price injected into the JSON-LD: the stable server-side subsidised price (mobile plan
   * applied, no Trade-In). Uses `priceWithoutTradeIn` (rather than `price`) as a defensive
   * runtime filter on `pickerGroup.id`, so the SEO price stays Trade-In-free even if the
   * `mobile-plan-pickers` response ever unexpectedly included a `trade_in` group — not just
   * relying on its response type never declaring one. When there are no mobile-plan pickers
   * (no `mobilePlanOfferId` / server call failed), it falls back to the raw `selectedOffer`
   * price, preserving the current non-subsidised JSON-LD.
   */
  const seoPrice = useProductPrice({
    pickers: mobilePlanPickersResponse,
    selectedOffer,
  }).priceWithoutTradeIn

  return {
    priceWithoutSubsidies: uiPrice.priceWithoutSubsidies,
    price: uiPrice.price,
    priceWithoutTradeIn: uiPrice.priceWithoutTradeIn,
    seoPrice,
  }
}
